/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-constant-condition */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
    TextField,
    Grid,
    Dialog,
    DialogTitle,
    Button,
    Icon,
    FormControl,
    Switch,
    Tooltip
} from '@mui/material';
import { Clear, Info } from '@mui/icons-material';
import { toast } from 'react-toastify';
import useStyles from '../styles';

export default function Services(props) {
    const classes = useStyles();
    const { allServicesObj } = useSelector((state) => state.constants.settings);
    const serviceFormat = {
        label: '',
        branches: {
            previous: {
                name: '',
                version: ''
            },
            current: {
                name: '',
                version: ''
            },
            next: {
                name: '',
                version: ''
            }
        },
        key: ''
    };
    const allServices = allServicesObj.map((s) => {
        const f = JSON.parse(JSON.stringify(serviceFormat));
        f.key = s.key;
        f.label = s.label;
        return f;
    });
    const { open, setOpenBuildDialog, startPreDeployment, editMode } = props;
    const s =
        props.clientSettings &&
        props.clientSettings.services &&
        props.clientSettings.services.length > 0
            ? props.clientSettings.services
            : allServices;
    const [services, setServices] = useState([...s]);
    const [selectedNewService] = useState('');
    const [setServicesAdded] = useState([...allServices.map((s) => s.key)]);
    const [newBranchDetails, setNewBranchDetails] = useState({
        key: '',
        label: ''
    });
    console.log('services:  - ', services);

    useEffect(() => {
        if (
            props.clientSettings &&
            props.clientSettings.services &&
            props.clientSettings.services.length
        ) {
            setServices(props.clientSettings.services);
            setServicesAdded([
                ...allServices
                    .map((s) => s.key)
                    .filter((r) => props.clientSettings.services.find((f) => f.key === r))
            ]);
        }
    }, [props.clientSettings]);

    function addNewService() {
        if (selectedNewService && selectedNewService.length && false) {
            const alreadyExists = services.some((service) => service.name === selectedNewService);
            if (!alreadyExists) {
                // const copyOfService = services;
                const newService = JSON.parse(JSON.stringify(serviceFormat));
                newService.name = selectedNewService;
                services.push(newService);
                setServices([...services]);
                setServicesAdded([
                    ...allServices
                        .map((s) => s.key)
                        .filter((r) => services.find((f) => f.key === r))
                ]);
            }
            console.log('added: ', services);
        }
        if (newBranchDetails && newBranchDetails.key.length && newBranchDetails.label.length) {
            const alreadyExists = services.some((service) => service.key === newBranchDetails.key);
            if (!alreadyExists) {
                // const copyOfService = services;
                // const newService = JSON.parse(JSON.stringify(serviceFormat));
                const newService = {
                    ...serviceFormat,
                    ...newBranchDetails
                };
                services.push(newService);
                setServices([...services]);
                setServicesAdded([
                    ...allServices
                        .map((s) => s.key)
                        .filter((r) => services.find((f) => f.key === r))
                ]);
                setNewBranchDetails({
                    key: '',
                    label: ''
                });
            }
            console.log('added: ', services);
        }
    }

    function saveServices() {
        props.setMainInfo({
            ...props.mainInfo,
            services
        });
        setOpenBuildDialog(false);
    }

    function setBranchName(value, index) {
        const s = services.map((f) => f);
        if (editMode) s[index].branches.current.name = value;
        else s[index].branches.next.name = value;
        setServices([...s]);
    }

    function checkToStartPreDeployment() {
        const r = services.filter((s) => s.branches.next.name && s.branches.next.name.length);
        if (!r.length) toast.info('Please specify branch names for the services to build');
        else if (
            !props.clientSettings.newReleaseVersion ||
            !props.clientSettings.newReleaseVersion.trim().length
        )
            toast.info('Please enter the release version');
        else startPreDeployment(services);
    }

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            disableEscapeKeyDown
            className={classes.buildDialog}
        >
            <DialogTitle className={classes.buildDialogTitle}>Select your branch</DialogTitle>
            <Icon onClick={() => setOpenBuildDialog(false)} className={classes.closeDialog}>
                <Clear />
            </Icon>
            <div className={classes.allServicesGrid}>
                {services &&
                    services.map((service, index) => (
                        <Grid
                            container
                            className={[classes.pb30, classes.serviceGrid]}
                            key={service.name}
                        >
                            <span className={classes.serviceName}>{service.label}</span>
                            {/* <span className={classes.version}>Version 2.0.2</span> */}
                            <TextField
                                id="outlined-basic"
                                variant="outlined"
                                className={classes.serviceInput}
                                value={
                                    editMode
                                        ? service.branches.current.name
                                        : service.branches.next.name
                                }
                                onChange={(e) => setBranchName(e.target.value, index)}
                                placeholder="Branch name"
                            />
                        </Grid>
                    ))}
                <Grid container className={[classes.pb30, classes.serviceGrid]}>
                    <FormControl sx={{ width: 223 }}>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            className={classes.serviceInput}
                            value={newBranchDetails.key}
                            placeholder="Enter key"
                            onChange={(e) =>
                                setNewBranchDetails({
                                    ...newBranchDetails,
                                    key: e.target.value
                                })
                            }
                        />
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            className={classes.serviceInput}
                            value={newBranchDetails.label}
                            placeholder="Enter label"
                            onChange={(e) =>
                                setNewBranchDetails({
                                    ...newBranchDetails,
                                    label: e.target.value
                                })
                            }
                        />
                    </FormControl>
                    <Button
                        variant="text"
                        className={classes.closeDialog}
                        onClick={() => addNewService()}
                    >
                        Add a new service
                    </Button>
                </Grid>
                {!editMode ? (
                    <Grid container className={[classes.pb30, classes.serviceGrid]}>
                        <FormControl sx={{ width: 223 }} className={classes.deploymentDetails}>
                            <span className={classes.serviceName}>
                                Release Name
                                <span className={classes.releaseToggle}>
                                    <Switch
                                        checked={props.clientSettings?.upgradeStatus?.isRelease}
                                        onChange={(e) =>
                                            props.setCurrentClient({
                                                ...props.clientSettings,
                                                isRelease: e.target.checked
                                            })
                                        }
                                        inputProps={{ 'aria-label': 'controlled' }}
                                        size="small"
                                    />
                                    <Tooltip
                                        title="Set toggle on if deployment type is 'Patch'."
                                        style={{ color: '#9f9f9f' }}
                                    >
                                        <Info fontSize="small" />
                                    </Tooltip>
                                </span>
                            </span>
                            <TextField
                                id="outlined-basic"
                                variant="outlined"
                                className={classes.serviceInput}
                                value={
                                    props.clientSettings && props.clientSettings.newReleaseVersion
                                }
                                onChange={(e) =>
                                    props.setCurrentClient({
                                        ...props.clientSettings,
                                        newReleaseVersion: e.target.value
                                    })
                                }
                                placeholder="Release Version"
                            />
                        </FormControl>
                    </Grid>
                ) : (
                    ''
                )}
            </div>
            <Button
                variant="outlined"
                type="Submit"
                className={classes.buildButton}
                onClick={() => (editMode ? saveServices() : checkToStartPreDeployment())}
                disabled={!editMode && (!services || !services.length)}
            >
                {editMode ? 'Save' : 'Start'}
            </Button>
        </Dialog>
    );
}
